module.exports = __webpack_public_path__ + "static/media/peace.aa32f98a.png";